import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { fetchBillingShipping } from '../services/api';
import { billingShippingAtom } from '../atoms/billingShippingAtom';

/**
 * Custom hook to read the billing and shipping state.
 * Returns the billing and shipping information or null if not loaded/error.
 */
export const useBillingShippingState = () => {
  const billingShippingData = useAtomValue(billingShippingAtom);
  return billingShippingData;
};

/**
 * Custom hook to provide actions related to orders.
 * Currently provides a function to refetch orders.
 */
export const useBillingShippingActions = () => {
  const setBillingShipping = useSetAtom(billingShippingAtom);

  // Function to trigger a refetch of the billing and shipping information
  const getBillingShipping = useCallback(async () => {
    try {
      const response = await fetchBillingShipping();
      setBillingShipping(response);
    } catch (error) {
      console.error('[useCutoff] Failed to fetch cutoff:', error);
      // Clear data or set an error state on failure
      setBillingShipping(null);
    }
  }, [setBillingShipping]);

  return {
    getBillingShipping,
    setBillingShipping,
  };
};
